<template>
    <div class="swiper-content" ref="carouselRef">
        <el-carousel :height="swiperHeight + 'px'" indicator-position="outside">
            <el-carousel-item v-for="item in carouselList" :key="item.id">
                <el-image :src="item.path" style="width: 100%; height: 100%" />
            </el-carousel-item>
        </el-carousel>

    </div>
</template>

<script lang="ts" setup>
import { ConstantField } from '@/constant/ConstantField';
import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { Action, WithOptionalRest } from '@/typeDefine/CommonTypes';
import { CarouselType } from '@/typeDefine/EntityType';
import { CarouselList } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { onMounted, onUnmounted, ref, Ref } from 'vue'

const carouselRef: Ref<HTMLElement | null> = ref(null)

//轮播图初始高度
const swiperInitHeight: number = 600

//轮播图高度
const swiperHeight: Ref<number> = ref(swiperInitHeight)

//轮播列表
const carouselList: Ref<CarouselList['data']['carousel']> = ref([])

//检测轮播视口监听器
let observer: IntersectionObserver

const emit = defineEmits<{
    viewport: [boolean]
}>()

onMounted(() => {
    getCarousel()
    changeSwiperHeight()
    watchCarouselViewport()
    window.addEventListener('resize', changeSwiperHeight)
})

const watchCarouselViewport: Action = () => {

    observer = new IntersectionObserver(
        (entries) => {
            const entry = entries[0]
            
            //发送视口事件
            emit('viewport',entry.isIntersecting)
        },
        {
            root: null, // 视口
            threshold: 0.1 // 只要有一点进入视口就算可见
        }
    )

    if (carouselRef.value) {
        observer.observe(carouselRef.value)
    }
}

//动态改变轮播高度
const changeSwiperHeight: Action = () => {
    const width: number = window.innerWidth

    if (width <= 1000 && width > 768) {
        swiperHeight.value = 300
        return
    }

    if (width <= 768) {
        swiperHeight.value = 200
        return
    }

    swiperHeight.value = swiperInitHeight
}

//获取轮播图列表
const getCarousel: Action = async () => {

    const response: CarouselList = await Api.instance.getAllCarousel()

    UtilMethods.showMessageToast(response, false)

    if (response.code === ResponseCode.OK) {
        carouselList.value = response.data.carousel
        carouselList.value.map(item => item.path = `${item.path}`)
    }
}

onUnmounted(() => {
    window.removeEventListener('resize', changeSwiperHeight)
})

</script>

<style lang="css" scoped>
</style>